import { useEffect } from "react";

const SITE = "Vardhix Technologies Private Limited";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * useSeo — sets document title, meta description and structured data per page.
 */
export function useSeo({ title, description, breadcrumb }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Fintech and Digital Platform Technology`;
    document.title = fullTitle;

    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);

    upsertJsonLd("ld-org", {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: SITE,
      url: "https://vardhixtechnologies.com",
      email: "contact@vardhixtechnologies.com",
      description:
        "Vardhix Technologies Private Limited develops and operates fintech software, trading evaluation technologies, digital platforms, risk systems, automation solutions, and scalable technology products in India.",
      address: {
        "@type": "PostalAddress",
        streetAddress: "806, Gera Imperium Rise, Hinjewadi Phase 2",
        addressLocality: "Pune",
        addressRegion: "Maharashtra",
        addressCountry: "IN",
      },
      industry: "Information Technology, Fintech Software",
    });

    upsertJsonLd("ld-website", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: SITE,
      url: "https://vardhixtechnologies.com",
    });

    if (breadcrumb && breadcrumb.length) {
      upsertJsonLd("ld-breadcrumb", {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: window.location.origin + b.path,
        })),
      });
    }
  }, [title, description, breadcrumb]);
}
